import React from 'react';
import { Row, Col } from 'reactstrap';
import { STEP, STEP_STATUS } from '../procurementConstants';

// Procurement > Overview tab: a process banner + four step cards reflecting the
// completion state of each step. Steps become Completed via the Validity tab's
// "Save & Completed" (which marks all four at once, per the agreed model).
const STEP_CARDS = [
  {
    key: STEP.REQUIREMENT,
    no: 1,
    label: 'Procurement Requirement',
    icon: 'ri-file-list-3-line',
  },
  {
    key: STEP.SUPPORTING_DOCUMENT,
    no: 2,
    label: 'Supporting Document',
    icon: 'ri-file-text-line',
  },
  {
    key: STEP.DMUT,
    no: 3,
    label: 'Registered Supplier Invitation',
    icon: 'ri-mail-send-line',
  },
  {
    key: STEP.VALIDITY,
    no: 4,
    label: 'Validity',
    icon: 'ri-time-line',
  },
];

const ProcurementOverviewTab = ({ detail }) => {
  const steps = detail.steps || {};
  const cards = STEP_CARDS.map(s => ({
    ...s,
    done: steps[s.key] === STEP_STATUS.COMPLETED,
  }));
  const allStepsDone = cards.every(s => s.done);

  return (
    <Row>
      <Col sm={12}>
        <div className='d-flex align-items-center mb-2'>
          <div className='flex-grow-1'>
            <h5 className='mb-1'>
              <i className='ri-checkbox-circle-line me-2'></i>
              Procurement Process Overview
            </h5>
            <p className='text-muted mb-2 fs-12'>
              Review the completion status of each step, then submit the process
              for final validation.
            </p>
          </div>
        </div>
      </Col>

      <Col lg={12}>
        <div className={`ov-banner ${allStepsDone ? 'done' : 'pending'}`}>
          <i
            className={
              allStepsDone ? 'ri-checkbox-circle-line' : 'ri-time-line'
            }
          ></i>
          <div>
            <h6 className='mb-1 fw-semibold'>
              {allStepsDone ? 'All Steps Completed' : 'Steps Remaining'}
            </h6>
            <p className='mb-0 text-muted'>
              {allStepsDone
                ? 'All required steps have been successfully completed. You may now submit the process.'
                : 'Complete the Validity step (Save & Completed) to finish every step, then submit.'}
            </p>
          </div>
        </div>
      </Col>

      <Col lg={12}>
        <Row className='g-3 mt-1'>
          {cards.map(step => (
            <Col md={3} sm={6} key={step.no}>
              <div className={`ov-step ${step.done ? 'done' : ''}`}>
                <div className='ov-step-icon'>
                  <i className={step.icon}></i>
                </div>
                <div className='flex-grow-1'>
                  <div className='ov-step-no'>STEP {step.no}</div>
                  <h6 className='mb-2'>{step.label}</h6>
                  <span
                    className={`badge ${
                      step.done
                        ? 'bg-success-subtle text-success'
                        : 'bg-warning-subtle text-warning'
                    }`}
                  >
                    {step.done
                      ? STEP_STATUS.COMPLETED
                      : STEP_STATUS.IN_PROGRESS}
                  </span>
                </div>
                {step.done && (
                  <i className='ri-check-double-line ov-step-check'></i>
                )}
              </div>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default ProcurementOverviewTab;
